import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { StateCountry, Carrier, RatesSroMaster, FrtRatesBidcycles } from 'src/app/shared/common-components/common-structure';
import { HhgRateEditService } from 'src/app/services/hhg-rate-edit/hhg-rate-edit.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HhgRatesCsvDownloadService } from 'src/app/services/hhg-rates-csv-download/hhg-rates-csv-download.service';
import { FrtRatesBidcyclesService } from 'src/app/services/frt-rates-bidcycles/frt-rates-bidcycles.service';
import { ControlKeys } from '../ratefile-open/control-keys';
import { CarrierService } from 'src/app/services/carrier/carrier.service';

import { DownloadFileResponse } from 'src/app/shared/common-components/file-storage/downloadFileResponse';
import * as FileSaver from 'file-saver';
import {api_error, frt_download_success} from '../../shared/common-components/AppConstants';
import { HhgRatesCsvDownload } from '../hhg-rates-csv-download/hhgRatesCsvDownload';
import { FrtRatesCsvDownloadService } from 'src/app/services/frt-rates-csv-download/frt-rates-csv-download.service';

@Component({
    selector: 'app-frt-rates-csv-download',
    templateUrl: './frt-rates-csv-download.component.html',
    styleUrls: ['./frt-rates-csv-download.component.css'],
    standalone: false
})
export class FrtRatesCsvDownloadComponent implements OnInit {

  hhgCsvDownloadForm: UntypedFormGroup;
  effectiveDatesList: ControlKeys[];
  ratesBidcyclesList: FrtRatesBidcycles[];
  carrierList: Carrier[];
  sroList: RatesSroMaster[];
  origStateList: StateCountry[];
  destStateList: StateCountry[];
  stateCountryVar: string;

  controlId: string;
  carrierId: string[];
  sroMasterIdList: string[];
  originId: string;
  destinationId: string;
  ratesBidcyclesId: number;
  hhgRatesCsvDownload: HhgRatesCsvDownload;

  private tmssloader;
  showExport = false;
  controlChanged = false;
  scacChanged = false;
  sroChanged = false;
  originChanged = false;
  destinationChanged = false;

  constructor(private fb: UntypedFormBuilder,
              private hhgRateEditService: HhgRateEditService,
              private frtRatesCsvDownloadService: FrtRatesCsvDownloadService,
              private hhgRatesCsvDownloadService: HhgRatesCsvDownloadService,
              private frtRateBidcyclesService: FrtRatesBidcyclesService,
              private carrierService: CarrierService,
              public loader: LoadingService,
              private alertService: AlertService,
              private modalService: BsModalService) {

    }

  ngOnInit() {
    this.createForm();
    this.tmssloader = this.loader;
    this.populateEffectiveDatesDropdown();
    this.populateCarrierDropdown();
    this.populateSroDropdown();
    this.populateOriginDropdown();
    this.populateDestinationDropdown();
  }

  createForm() {
    this.hhgCsvDownloadForm =  this.fb.group({
      effectiveDates: new UntypedFormControl(''),
      scac: new UntypedFormControl(''),
      sro: new UntypedFormControl(''),
      origin: new UntypedFormControl(''),
      destination: new UntypedFormControl('')
    });
  }

  populateEffectiveDatesDropdown() {
    this.tmssloader.show();
    // this.hhgRatesCsvDownloadService.getEffectiveDates("FRT Rate Effective Dates").subscribe(allDates => {
      this.frtRateBidcyclesService.getRatesBidCyclesByBusinessTypes('FRT').subscribe(allRateCycles => {
      this.ratesBidcyclesList = allRateCycles;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving Effective Dates List');
    });
    this.controlChanged = false;
  }

  populateCarrierDropdown() {
    this.tmssloader.show();
    this.carrierService.getAllCarrierListByBusinessType('FRT').subscribe(carrierList => {
      this.carrierList = carrierList;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving TSP List');
    });
    this.scacChanged = false;
  }

  populateSroDropdown() {
    this.tmssloader.show();
    this.hhgRatesCsvDownloadService.getSros('FRT').subscribe(allSros => {
      this.sroList = allSros;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving Sro List');
    });
    this.sroChanged = false;
  }

  populateOriginDropdown() {
    this.tmssloader.show();
    this.stateCountryVar = 'stateAndCountry';
    this.hhgRateEditService.getStateCountry(this.stateCountryVar).subscribe(allState => {
      this.origStateList = allState;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving State List');
    });
    this.originChanged = false;
  }

  populateDestinationDropdown() {
    this.tmssloader.show();
    this.stateCountryVar = 'stateAndCountry';
    this.hhgRateEditService.getStateCountry(this.stateCountryVar).subscribe(allState => {
      this.destStateList = allState;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving State List');
    });
    this.destinationChanged = false;
  }

  effectiveDatesChange(ratesBidcyclesId: any) {
   // this.controlId = ratesBidcyclesId;
   this.ratesBidcyclesId = ratesBidcyclesId;
    this.controlChanged = true;
  }
  scacChange(carrierId: any) {
    this.carrierId = (JSON.parse(JSON.stringify(this.hhgCsvDownloadForm.value)).scac);  
    if (this.carrierId.length > 10) {
      this.alertService.error("The maximum number of SCACs allowed to select is 10");
      this.scacChanged = false;
    } else {
      this.scacChanged = true;
    }    
  }
  sroChange(sroMasterIdList: any[]) {
    this.sroMasterIdList = (JSON.parse(JSON.stringify(this.hhgCsvDownloadForm.value)).sro);
    if (this.sroMasterIdList.indexOf('0') != -1)
    {
      if (this.sroMasterIdList.length > 1){
        this.alertService.error("Remove other SROs when selecting All SROs")
        this.sroChanged = false;
      } else {
        this.sroChanged = true;
      }
    } else {
      this.sroChanged = true;
    }   
  }
  originChange(originId: any) {
    this.originId = originId;
    this.originChanged = true;
  }
  destinationChange(destinationId: any) {
    this.destinationId = destinationId;
    this.destinationChanged = true;
  }
  buildData() {
    this.hhgRatesCsvDownload = new HhgRatesCsvDownload();
    this.hhgRatesCsvDownload.carrierId = this.carrierId;
    this.hhgRatesCsvDownload.controlId = this.controlId;
    this.hhgRatesCsvDownload.ratesBidcyclesId = this.ratesBidcyclesId;
    this.hhgRatesCsvDownload.sroMasterIdList = this.sroMasterIdList;
    this.hhgRatesCsvDownload.originId = this.originId;
    this.hhgRatesCsvDownload.destinationId = this.destinationId;
  }
  /*
  download() {
    let hhgrRatesResult: DownloadFileResponse;
    this.tmssloader.show();
    this.buildData();
    console.log(this.hhgRatesCsvDownload);
    this.frtRatesCsvDownloadService.exportDataFromServer(this.hhgRatesCsvDownload).subscribe(
     (data: any) => {
      hhgrRatesResult = data as DownloadFileResponse;
      const byteData: number[] = hhgrRatesResult.byteData;
      const fileName: string = hhgrRatesResult.fileName;
      const numRows: number = hhgrRatesResult.numberOfExcelRows;
      const bytes = new Uint8Array(byteData);
      const blob = new Blob([bytes], {
        type: null
      });
      console.log(numRows);
      FileSaver.saveAs(blob, fileName);
      this.alertService.success(frt_download_success);
      this.showExport = false;
      this.tmssloader.hide();
      setTimeout(() => {
        this.showExport = true;
      }, 5200);
    }, error => {
      this.alertService.error(api_error);
      this.tmssloader.hide();
    });
  }*/

  download() {
    this.buildData();
    this.frtRatesCsvDownloadService.exportDataFromServer(this.hhgRatesCsvDownload).subscribe();
    this.alertService.success("Your download request has been received. System will create the file and notify you via email once the file is ready");
  }

}
